import { useFormikContext } from "formik";
import {
  DisplayFormErrors,
  DrawerFooterContent,
  InputField,
  SelectField,
  SwitchField,
  useCultures,
  VerticalForm,
} from "melco-shared-logic";
import { Button, Row, Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

type DisplayUpgradeLicenseFormProps = {
  //callback:(v:any)=> any
};
const AlertWrapper = styled.div`
  margin-top: 25px;
`;

export const DisplayUpgradeLicenseForm: React.FC<
  DisplayUpgradeLicenseFormProps
> = ({}) => {
  const { t } = useTranslation();
  const { submitForm } = useFormikContext();
  const { cultures } = useCultures();

  return (
    <>
      <div>
        <Title level={4}>
          {t("licensemanager.upgrade.steps.checklicense")}
        </Title>
        <VerticalForm>
          <AlertWrapper>
            <DisplayFormErrors />
          </AlertWrapper>
          <InputField
            name="melco_customer_id"
            label={t("licensemanager.upgrade.form.melco_customer_id")}
          />
          <InputField
            name="email_address"
            label={t("licensemanager.upgrade.form.email")}
          />

          <InputField
            name="serial_number"
            label={t("licensemanager.upgrade.form.serial_number")}
          />
          <SelectField
            name="language"
            label={t("licensemanager.upgrade.form.language")}
            options={cultures.map((culture) => {
              return {
                label: culture.name,
                value: culture.code,
              };
            })}
            showSearch
            optionFilterProp="label"
            info={t("licensemanager.create.form.languageinfo")}
            // onChange={(value: string, obj: DropDownValueLabelObj) => {
            //   callBackForLanguage(value, obj);
            // }}
          />
          <SwitchField name="assign_license" label="Don't assign license" />
          <DrawerFooterContent>
            <Row justify="end">
              <Button
                style={{ minWidth: "80px" }}
                key="add-user-button"
                type="primary"
                onClick={() => {
                  //callback(createConfirmDetailsToDisplay);
                  submitForm();
                }}
              >
                {t("licensemanager.buttons.next")}
              </Button>
            </Row>
          </DrawerFooterContent>
        </VerticalForm>
      </div>
    </>
  );
};
